/* Progressive enhancement for the consign page: Ask Joey opens chat in place, a copy button for the intake address, and consent-gated GA4 clicks. The page works fully without this file. */
(() => {
  'use strict';
  if (window.wnfcInitialized) return;
  window.wnfcInitialized = true;
  const measurementId = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, {
      send_to: measurementId,
      page_location: 'https://whatsnewfurniture.com/pages/consign-furniture-portland',
      ...params
    });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }

  const init = () => {
    const page = document.querySelector('[data-wnfc-page]');
    if (!page) return;

    // Capture phase, so this runs before Motion's link handler starts its page transition.
    document.addEventListener('click', (event) => {
      const email = event.target.closest('[data-wnfc-email]');
      if (email) track('wnf_consign_email_click', { cta_placement: email.dataset.wnfcEmail, transport_type: 'beacon' });
      const chat = event.target.closest('[data-wnfc-chat]');
      if (chat && typeof window.WNFChatOpen === 'function') {
        event.preventDefault();
        window.WNFChatOpen();
        track('wnf_consign_chat_open');
      }
    }, true);

    const copy = page.querySelector('[data-wnfc-copy]');
    if (copy && navigator.clipboard?.writeText && window.isSecureContext) {
      const label = copy.querySelector('[data-wnfc-copy-label]');
      const original = label.textContent;
      let timer;
      copy.hidden = false;
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(copy.dataset.wnfcCopy);
          label.textContent = 'Copied. Paste it into your email.';
          track('wnf_consign_copy_email');
        } catch {
          label.textContent = 'Copy didn’t work. The address is above.';
        }
        clearTimeout(timer);
        timer = setTimeout(() => { label.textContent = original; }, 4000);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
